import { useQueryClient, useQuery, QueryResult, UseQueryOptions } from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import type { AccountNumber, Card, DebitCardDetailEndpoint } from '../generated-types';
import { getCardLink, getCardsOverview } from '../services/creditcardService';

type DebitCardQueryOptions = Omit<
    UseQueryOptions<DebitCardDetailEndpoint[], RequestExceptionWithResponse>,
    'queryKey' | 'queryFn' | 'initialData'
>;

export const useDebitcardLink = (
    accountNumber?: AccountNumber,
    { enabled, ...options }: DebitCardQueryOptions = {},
): QueryResult<DebitCardDetailEndpoint[]> =>
    useQuery({
        ...options,
        queryKey: ['debitcard'],
        queryFn: () => getCardLink(accountNumber!),
        staleTime: Infinity,
        enabled: !!accountNumber && enabled,
    });

export const useCreditcards = (accountNumbers: string[], enabled: boolean): QueryResult<Card[]> => {
    const select = (data: Card[]) => data.filter((card) => !accountNumbers.includes(card.accountNumber.value));
    return useQuery({
        queryKey: ['creditcards'],
        queryFn: () => getCardsOverview(),
        enabled,
        staleTime: Infinity,
        select,
    });
};

export const useRefreshCreditCards = () => {
    const queryClient = useQueryClient();
    return () => queryClient.invalidateQueries({ queryKey: ['creditcards'] });
};
